<template>
    <div id="health-plans" class="container">

        <template v-if="list">
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <h1 id="crbg-header" class="text-uppercase">{{ title }}</h1>
                    <img src="/images/crbg/health-plans/header_image.jpg" class="embed-responsive object-position-68" alt="Main learning image"/>
                </div>
            </div>
            <div class="row justify-content-center sb-my-health mt-5">
                <div class="col-md-12 mb-3">
                    <div class="left-header">
                        <img src="/images/crbg/health-plans/checklist_icon.svg" class="float-left" alt="Checklist Icon">
                        <h1 class="sb-left-header pt-2">{{ title }}</h1>
                    </div>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="row justify-content-center sb-my-health">
                <div class="col-md-9 mb-3">
                    <h1 class="sb-main-header pt-2">{{ title }}</h1>
                </div>
            </div>
            <div class="align-items-center justify-content-between row mb-3">
                <div class="col-md-3 text-left">
                    <a href="#" @click.prevent="showPlans" class="back-link">
                        <div class="left-header">
                            <div class="float-left back-arrow"> Back to my Benefits</div>
                        </div>
                    </a>
                </div>
                <div v-if="showPayments" class="col-md-6 text-center showPayments--text">
                    All transactions processed for your account are shown in the areas below. You can use the export
                    button to download and save these to an Excel spreadsheet format.
                </div>
                <div v-if="showPayments" class="col-md-3 text-center"></div>
                <div v-else class="col-md-6 mt-3 header-right-btn">
                    <a v-if="false && healthplanD.plantype!='O'" class="btn btn-primary btn-sb-red float-right ml-2"
                       @click="showModal = true"
                    >
                        Print & Fax My Personal Health Record
                    </a>
                    <a v-if="healthplanD.payments.length > 0 && healthplanD.planname!='UBLIC (Retiree)'"
                       class="btn btn-primary btn-sb-red float-right"
                       @click="openPayments(healthplanD)"
                    >
                        View All Payments
                    </a>
                </div>
                <!-- Modal -->
                <div v-if="showModal">
                    <transition name="modal">
                        <div class="modal-mask">
                            <div class="modal-wrapper">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Send Personal Health Record</h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true" @click="showModal = false">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body" id="phr-form">
                                            <div class="form-group row" v-if="false">
                                                <label for="email" class="col-sm-4 col-form-label">Way to send</label>
                                                <div class="col-sm-8">
                                                    <select v-model="sendData.type" id="type" name="type" class="form-control required">
                                                        <option>Please Select</option>
                                                        <option v-for="t in types" :value="t">{{t}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="form-group">

                                            </div>
                                            <div class="form-group row" v-if="sendData.type === 'email'">
                                                <label for="email" class="col-sm-4 col-form-label">Email</label>
                                                <div class="col-sm-8">
                                                    <input type="text" class="form-control required" id="email" name="email" v-model="sendData.email">
                                                </div>
                                            </div>
                                            <div class="form-group row" v-if="sendData.type === 'fax'">
                                                <label for="email" class="col-sm-4 col-form-label">Fax Number</label>
                                                <div class="col-sm-8">
                                                    <input type="text" class="form-control required" id="faxNumber" name="faxNumber" v-model="sendData.faxNumber">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-secondary" @click="showModal = false">Close</button>
                                            <button v-if="(sendData.type === 'email' && sendData.email !== '') || (sendData.type === 'fax' && sendData.faxNumber!=='')" type="button" class="btn btn-primary" @click="send">Send</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </template>


        <div v-if="list" class="row">
            <div class="col-md-4 mt-4 hp-cards" v-for="healthplan in healthplans">
                <plan-card-medical v-if="healthplan.plantype=='M'" :elig="elig" :showbtns="!(healthplans.some(hp=>hp.provider === 'UHC') && healthplans.some(hp=>hp.provider === 'UMR'))" :healthplan="healthplan"></plan-card-medical>
                <plan-card-rx v-if="healthplan.plantype=='R'" :healthplan="healthplan" :envoptum="envoptum"></plan-card-rx>
                <plan-card-other-gtli v-if="healthplan.plantype=='O' && healthplan.planname=='Group Term Life Insurance'" :healthplan="healthplan"></plan-card-other-gtli>
                <plan-card-other-ublic v-if="healthplan.plantype=='O' && healthplan.planname=='UBLIC'" :healthplan="healthplan"></plan-card-other-ublic>
                <plan-card-other-ublic-retiree v-if="healthplan.plantype=='O' && healthplan.planname=='UBLIC (Retiree)'" :healthplan="healthplan"></plan-card-other-ublic-retiree>
                <plan-card-other-irp v-if="healthplan.plantype=='O' && healthplan.planname=='Income Replacement Plan'" :healthplan="healthplan"></plan-card-other-irp>
                <plan-card-other-gap v-if="healthplan.plantype=='O' && healthplan.planname=='Group Accident Plan'" :healthplan="healthplan"></plan-card-other-gap>
<!--                <plan-card-other v-if="healthplan.plantype=='O'" :healthplan="healthplan"></plan-card-other>-->
            </div>
            <div class="col-md-12" v-if="elig.memberdata['sso_flag'].includes('5')
                &&
                healthplans.find(plan => plan.plantype === 'M')
                &&
                Array.isArray(healthplans.find(plan => plan.plantype === 'M').dependents)
                &&
                healthplans.find(plan => plan.plantype === 'M').dependents.length > 0
                ">
                <div class="row justify-content-center sb-my-health mt-5">
                    <div class="col-md-12 mb-3">
                        <div class="left-header">
                            <img src="/images/crbg/health-plans/checklist_icon.svg" alt="Checklist Icon" class="float-left">
                            <h1 class="sb-left-header pt-2">DEPENDENT COVERAGE</h1>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 mt-4 hp-cards">
                        <div class="card border-0">
                            <div class="card-header">
                                <span>Related Coverage</span>
                            </div>
                            <div class="card-body gray-bg">
                                <ul class="list-group mb-3">
                                    <li class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0">
                                        <div class="row  ">
                                            <div class="col-md-6 sb-benefit-list-title">
                                                Dependent ID
                                            </div>
                                            <div class="col-md-6  sb-benefit-list-value">
                                                {{ healthplans.find(plan => plan.plantype === 'M')?.dependents?.[0]?.dependent_id.substring(0, healthplans.find(plan => plan.plantype === 'M')?.dependents?.[0]?.dependent_id.length - 2) }}
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0">
                                        <div class="row  ">
                                            <div class="col-md-6 sb-benefit-list-title">
                                                Group #
                                            </div>
                                            <div class="col-md-6  sb-benefit-list-value">
                                                {{ healthplans.find(plan => plan.plantype === 'M')?.dependents?.[0]?.group_number }}
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item border-top-0 border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0">
                                        <div class="row">
                                            <div class="col-md-6 sb-benefit-list-title">
                                                Dependent name
                                            </div>
                                            <div class="col-md-6  sb-benefit-list-value">
                                                {{ healthplans.find(plan => plan.plantype === 'M')?.dependents?.[0]?.first_name }} {{ healthplans.find(plan => plan.plantype === 'M')?.dependents?.[0]?.last_name }}
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0" v-if="healthplans.find(plan => plan.plantype === 'M')?.dependents?.[0]?.effective_date">
                                        <div class="row  ">
                                            <div class="col-md-6 sb-benefit-list-title">
                                                Effective Date
                                            </div>
                                            <div class="col-md-6  sb-benefit-list-value">
                                                {{healthplans.find(plan => plan.plantype === 'M')?.dependents?.[0]?.effective_date}}
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0" v-if="healthplans.find(plan => plan.plantype === 'M')?.dependents?.[0]?.termination_date">
                                        <div class="row  ">
                                            <div class="col-md-6 sb-benefit-list-title">
                                                Termination Date
                                            </div>
                                            <div class="col-md-6  sb-benefit-list-value">
                                                {{healthplans.find(plan => plan.plantype === 'M')?.dependents?.[0]?.termination_date}}
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <div class="text-center mb-3 btn-hp">
                                    <a href="#" @click.prevent="ssoClickNew('UMR')" class="btn-primary btn">
                                        {{ ssoButtonText(['UMR', 'UHC'].find(value => value !== healthplans.find(plan => plan.plantype === 'M').provider)) }}
                                    </a>
                                </div>
                            </div>
                            <div id="sso" v-html="sso" ref="sso"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <plan-medical
            v-if="showPlanMedical"
            :healthplanD="healthplanD"
            :wellnessrewardssitecontentid="wellnessrewardssitecontentid"
            :showwellnessrewards="showwellnessrewards"
            :userovereighteen="userovereighteen"
            :elig="elig"
            :ip="ip"
            :showbtns="!(healthplans.some(hp=>hp.provider === 'UHC') && healthplans.some(hp=>hp.provider === 'UMR'))"
        ></plan-medical>
        <plan-rx v-if="showPlanRx" :healthplanD="healthplanD" :envoptum="envoptum"></plan-rx>
        <plan-other v-if="showPlanOther" :healthplanD="healthplanD"></plan-other>
        <plan-other-gap v-if="showPlanOtherGap" :healthplanD="healthplanD"></plan-other-gap>
        <payments-history v-if="showPayments" :planName="healthplanD.planname" :payments="healthplanD.payments"></payments-history>
    </div>
</template>

<script>

import PlanCardMedical from "./PlanCardMedical";
export default {
    name: 'HealthPlans',
    components: {PlanCardMedical},
    props: ['healthplans','ssobtn', 'wellnessrewardssitecontentid', 'showwellnessrewards','envoptum', 'userovereighteen',
        'elig', 'ip'],
    data() {
        return {
            list: true,
            showModal: false,
            healthplanD: {},
            view_more: false,
            showPayments: false,
            showPlanMedical: false,
            showPlanOther: false,
            showPlanOtherGap: false,
            showPlanRx: false,
            sendData:{
                email:'',
                faxNumber:'',
                type:'fax'
            },
            types:[
                'email',
                'fax'
            ]
        }
    },
    computed: {
        title() {
            if (this.list) {
                return 'MY COVERAGE';
            }
            if (this.showPlanRx) {
                return 'PRESCRIPTIONS';
            }
            if (this.showPayments) {
                return "TRANSACTION HISTORY";
            }

            return this.healthplanD.planname;
        },
    },
    methods: {
        getPhones(healthplan, half) {
            let phones = [..._.filter(this.findFieldGroup(healthplan.hpd_fields[0].children, "contact"), {fieldtype: "phone"}).map(item => {
                return {
                    title: item.label,
                    phone: item.value
                }
            }), ...healthplan.hpc.map(item => {
                return {
                    title: item.title,
                    phone: item.phone
                }
            })]
            if (half == 1)
                return phones.slice(0, Math.floor(phones.length / 2))
            else
                return phones.slice(Math.floor(phones.length / 2), phones.length)

        },
        findFieldGroup(fields, fieldGroup) {
            let data = [];
            _.forEach(fields, (value, key) => {
                if (
                    value.fieldgroup == fieldGroup
                ) {
                    data.push(value);
                }
                if (value.children.length > 0) {
                    data = [...data, ...this.findFieldGroup(value.children, fieldGroup)];
                }
            })
            return data;
        },
        openDetailedView(healthplan) {
            this.healthplanD = healthplan;
            this.list = false
            window.scrollTo({ top: 0, behavior: 'smooth' });

            if (healthplan.plantype === "M") {
                this.showPlanMedical = true;
            } else if (healthplan.plantype === "R") {
                this.showPlanRx = true;
            } else if (healthplan.plantype === "O") {
                if(healthplan.plancode=='GAP-Mutual'){
                    this.showPlanOtherGap=true;
                }else{
                    this.showPlanOther = true;
                }

            }

            this.$router.push({ name: 'healthplans.detail', params: {planSlug: healthplan.slug} });
        },
        getHpSummaryFields(fields, type) {
            let data = [];
            if (type == 'M') {
                data = [...data, ...this.findField(fields, 'PCP Office Visit - Copay')];
                data = [...data, ...this.findField(fields, 'Premium Designated PCP')];
                data = [...data, ...this.findField(fields, 'Urgent Care - Copay')];
                data = [...data, ...this.findField(fields, 'ER Copay')];
                data = [...data, ...this.findField(fields, 'Emergency Room - Copay')];
            }
            if (type == 'R') {
                data = [...data, ...this.findField(fields, 'Rx BIN Number')];
                data = [...data, ...this.findField(fields, 'BIN Number')];
                data = [...data, ...this.findField(fields, 'PCN Number')];
                data = [...data, ...this.findField(fields, 'Copay 30-day Generic')];
                data = [...data, ...this.findField(fields, 'Copay 90-day Generic')];
                data = [...data, ...this.findField(fields, 'Home Delivery Copay 90-day Generic')];
            }
            if (type == 'D') {
                data = [...data, ...this.findField(fields, 'Preventive (Class I)')];
                data = [...data, ...this.findField(fields, 'Major (Class III)')];
                data = [...data, ...this.findField(fields, 'Orthodontia (Class IV)')];
            }
            if (type == 'V') {
                data = [...data, ...this.findField(fields, 'Annual Eye Exam')];
                data = [...data, ...this.findField(fields, 'Frames')];
                data = [...data, ...this.findField(fields, 'Standard Plastic Lenses: Single Vision')];
            }
            if (type == 'O') {
                data = [...data, ...this.findField(fields, 'Coverage Amount')];
                data = [...data, ...this.findField(fields, 'Coverage Type')];
            }
            return data
        },
        findField(fields, label) {
            let data = [];
            _.forEach(fields, (value, key) => {
                if (
                    value.label == label
                ) {
                    data.push(value);
                }
                if (value.children.length > 0) {
                    data = [...data, ...this.findField(value.children, label)];
                }
            })
            return _.take(data, 1);
        },
        firstTreeFields(fields) {
            let data = [];
            _.forEach(fields, (value, key) => {
                if (
                    // value.value!='' &&
                    value.children.length == 0 &&
                    value.label != 'Family' &&
                    value.label != 'Individual' &&
                    value.fieldgroup != 'contact'
                ) {
                    data.push(value);
                }
                if (value.children.length > 0) {
                    data = [...data, ...this.getFields(value.children)];
                }
            })
            return _.take(data, 3);
        },
        getFields(fields) {
            let data = [];
            _.forEach(fields, (value, key) => {
                if (
                    // value.value!='' &&
                    value.children.length == 0 &&
                    value.label != 'Family' &&
                    value.label != 'Individual' &&
                    value.fieldgroup != 'contact'
                ) {
                    data.push(value);
                }
                if (value.children.length > 0) {
                    data = [...data, ...this.getFields(value.children)];
                }
            })
            return data;
        },
        outputDate(i) {
            return moment(i.created_at).utc().format('MMMM DD, YYYY')
        },
        log(s) {
            console.log(s)
        },
        _handleErrors: function (items, selector) {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()

            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="' + name + '"]')
                    el.closest('.form-group').addClass('has-error')
                    $('<p class="help-block">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                }
            }
        },
        showPlans() {
            this.switchTemplate('list');

            this.$router.push({ name: 'healthplans' });
        },
        showViewAll(healthPlan) {
            return healthPlan.plantype === "O" && healthPlan.beneficiaries.length > 0;
        },
        switchTemplate(template) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.list = template === 'list';
            this.showPlanMedical = template === 'medical';
            this.showPlanRx = template === 'rx';
            this.showPlanOther = template === 'other';
            this.showPlanOtherGap = template === 'other';
            this.showPayments = template === 'payments';
        },
        ssoButtonText(provider) {
            if(!this.ssobtn)
                return false;
            return {
                'ESI': 'Go To Express Scripts',
                'UMR': 'Go To UMR',
                'UMR_RETIRED': 'Go To UMR Retired',
                'UHC': 'Go To UHC',
                'OptumRx': 'Go To Optum Rx'
            }[provider] || false;
        },
        openPayments(healthplan) {
            this.healthplanD = healthplan;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.switchTemplate('payments');

            this.$router.push({ name: 'healthplans.payments', params: { planSlug: healthplan.slug } });
        },
        send(){
            this.$http.post('/api/sendPHR', this.sendData)
                .then(function(response) {
                    $('.has-error').removeClass('has-error')
                    $('.help-block').remove()
                    this.showModal = false;
                }, (response) => {
                    this.handleFaxErrors(response.data, '#phr-form')
                })
        },
        handleFaxErrors: function(items, selector)
        {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()

            for (const error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    const name = error.split('.').pop();
                    const el = $(selector + ' [name="' + name + '"]');
                    el.closest('.form-group').addClass('has-error')
                    $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                }
            }
        },
        planTitle(healthplan) {
            return healthplan.plantype === "R" ? "Rx" : healthplan.planname;
        },
        showProductType(value){
            switch (value){
                case 'NYL - TL':
                    return 'NYL - TL (G-29297-1)';
                    break;
                case 'UBLIC - UB':
                    return 'UBLIC (G-29297-0)';
                    break;
                case 'UBLIC (Retiree)':
                    return 'UBR (GLU-414)';
                    break;
                case 'UBLIC - UBR':
                    return 'UBR (GLU-414)';
                    break;
                default:
                    return value;
            }
        },
        ssoClickNew(provider, path = '') {
            const newPath = path ? `&path=${path}` : '';
            const baseUrl = `${window.location.origin}/dashboard`;
            window.open(`${baseUrl}?provider=${provider.toLowerCase()}${newPath}`, '_blank');
        },
    },
    mounted() {
        if (this.$route.name === 'healthplans.detail') {
            const hpdSlug = this.$route.params.planSlug
            const hp = this.healthplans.find(h => h.slug === hpdSlug)

            this.openDetailedView(hp)
        }
        if (this.$route.name === 'healthplans.payments') {
            const planSlug = this.$route.params.planSlug
            const hp = this.healthplans.find(h => h.slug == planSlug)

            this.openPayments(hp)
        }

        window.addEventListener('popstate', _ => window.location.reload(), false)
    },
}
</script>

<style scoped>

</style>
